import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "m8.75 8.75 3-6 3 6 6 1-5 5 2 6-6-3-6 3 2-6-5-5 6-1Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M11.75 2a.75.75 0 0 1 .67.415l2.83 5.658 5.623.937a.75.75 0 0 1 .407 1.27l-4.672 4.673 1.854 5.56a.75.75 0 0 1-1.047.908l-5.665-2.832-5.665 2.832a.75.75 0 0 1-1.046-.908l1.853-5.56L2.22 10.28a.75.75 0 0 1 .407-1.27l5.623-.937 2.83-5.658A.75.75 0 0 1 11.75 2Zm0 2.427L9.42 9.085a.75.75 0 0 1-.547.405l-4.562.76 3.97 3.97c.2.2.27.498.18.767L7.035 19.27l4.38-2.19a.75.75 0 0 1 .671 0l4.38 2.19-1.426-4.282a.75.75 0 0 1 .18-.767l3.97-3.97-4.562-.76a.75.75 0 0 1-.548-.405l-2.33-4.659Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n,
  a
];
function d(r, s) {
  return l(), t("svg", o, [...c]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
